import React from 'react'
import FormAdmin from '../../Components/FormAdmin'

const AjouterAdmin = () => {
  return <FormAdmin />
}

export default AjouterAdmin
